/* eslint-disable react-hooks/exhaustive-deps */
/* รายการ RC ทั้งหมด   /support/rc */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Button, Card, Flex, Input, Segmented, Select, Table, Tag, Typography, message } from "antd";
import { PaperClipOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { RC_STATUS, RC_TYPES, RcStatusTag, RcTypeTag, costText } from "../../../components/ak/rc";
import { RcService, apiError } from "../../../service/Ak.service";
import { usePermission } from "../../../store/context/permission-context";
import RcCreateModal from "./RcCreateModal";

export default function RcAccess() {
  const navigate = useNavigate();
  const { can } = usePermission();
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [type, setType] = useState();
  const [status, setStatus] = useState("ค้างอยู่");
  const [creating, setCreating] = useState(false);

  const load = () => {
    setLoading(true);
    RcService.list({ q: q || undefined, type }, { ignoreLoading: true })
      .then((r) => setAll(r.data?.data || []))
      .catch((e) => message.error(apiError(e)))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [q, type]);

  const OPEN = ["รอรับเรื่อง", "รับเรื่องแล้ว", "อนุมัติ"];
  const count = (s) => all.filter((r) => (s === "ค้างอยู่" ? OPEN.includes(r.status) : s === "ทั้งหมด" ? true : r.status === s)).length;
  const rows = all.filter((r) => (status === "ทั้งหมด" ? true : status === "ค้างอยู่" ? OPEN.includes(r.status) : r.status === status));

  const columns = [
    {
      title: "เรื่อง",
      dataIndex: "rc_code",
      render: (v, r) => (
        <div>
          <Typography.Link strong onClick={() => navigate(`view/${v}`)}>
            {r.title}
          </Typography.Link>
          <div style={{ fontSize: 12, color: "#8c8c8c" }}>
            {v} <RcTypeTag value={r.rc_type} />
            {Number(r.file_count) > 0 && (
              <span>
                <PaperClipOutlined /> {r.file_count}
              </span>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "โปรเจ็กต์ / ลูกค้า",
      key: "pj",
      render: (_, r) => (
        <div>
          <Typography.Link onClick={() => navigate(`/support/project/view/${r.project_code}`)}>{r.project_name}</Typography.Link>
          <div style={{ fontSize: 12, color: "#8c8c8c" }}>{[r.prename, r.cus_name].filter(Boolean).join(" ")}</div>
        </div>
      ),
    },
    { title: "สถานะ", dataIndex: "status", render: (v) => <RcStatusTag value={v} /> },
    { title: "ยอดเงิน", dataIndex: "cost_change", align: "right", render: (v) => costText(v) || "-" },
    { title: "แจ้งโดย", dataIndex: "created_by_type", render: (v) => (v === "customer" ? <Tag color="orange">ลูกค้า</Tag> : <Tag>เจ้าหน้าที่</Tag>) },
    { title: "วันที่แจ้ง", dataIndex: "created_date", render: (v) => dayjs(v).format("DD/MM/YYYY HH:mm") },
    {
      title: "ลูกค้าตอบล่าสุด",
      dataIndex: "last_customer_date",
      render: (v, r) =>
        v ? (
          <Badge dot={!r.replied_date || dayjs(v).isAfter(dayjs(r.replied_date))} offset={[6, 0]}>
            {dayjs(v).format("DD/MM HH:mm")}
          </Badge>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <Card className="ak-card">
      <Flex justify="space-between" align="center" wrap="wrap" gap={8} className="mb-3">
        <div>
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            RC · ลูกค้าแจ้งเปลี่ยนแปลง
          </Typography.Title>
          <Typography.Text type="secondary">งานลด/งานเพิ่ม · แก้ไขแบบ · อื่นๆ — ลูกค้าแจ้งจาก /portal หรือเจ้าหน้าที่บันทึกแทน</Typography.Text>
        </div>
        {can("support_rc", "add") && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setCreating(true)}>
            แจ้ง RC แทนลูกค้า
          </Button>
        )}
      </Flex>

      <Flex gap={8} wrap="wrap" className="mb-3">
        <Input allowClear prefix={<SearchOutlined />} placeholder="ค้นหา เลขที่ / หัวข้อ / โปรเจ็กต์ / ลูกค้า" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: 300 }} />
        <Select allowClear placeholder="ทุกประเภท" value={type} onChange={setType} style={{ width: 170 }} options={RC_TYPES.map((t) => ({ value: t, label: t }))} />
      </Flex>
      <div className="mb-3" style={{ overflowX: "auto" }}>
        <Segmented value={status} onChange={setStatus} options={["ค้างอยู่", ...RC_STATUS, "ทั้งหมด"].map((s) => ({ value: s, label: `${s} (${count(s)})` }))} />
      </div>

      <Table
        rowKey="rc_code"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={rows}
        scroll={{ x: "max-content" }}
        onRow={(r) => ({ onDoubleClick: () => navigate(`view/${r.rc_code}`) })}
        pagination={{ pageSize: 25, showTotal: (t) => `ทั้งหมด ${t} เรื่อง` }}
      />

      <RcCreateModal
        open={creating}
        onClose={() => setCreating(false)}
        onDone={(rc) => {
          setCreating(false);
          navigate(`view/${rc.rc_code}`);
        }}
      />
    </Card>
  );
}
